import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import ApiIcon from '../components/ApiIcon';

const ApiPage: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60vh',
                    textAlign: 'center',
                }}
            >
                <Box sx={{ mb: 3 }}>
                    <ApiIcon sx={{ fontSize: 80, color: '#C10B50', opacity: 0.7 }} />
                </Box>

                <Typography
                    variant="h3"
                    component="h1"
                    gutterBottom
                    sx={{
                        fontWeight: 600,
                        color: '#18010a',
                        mb: 2
                    }}
                >
                    API Management
                </Typography>

                <Typography
                    variant="h5"
                    component="h2"
                    sx={{
                        color: '#666',
                        mb: 3,
                        fontWeight: 400
                    }}
                >
                    Coming Soon
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: '#888',
                        maxWidth: 600,
                        lineHeight: 1.6
                    }}
                >
                    We're developing a comprehensive API management platform for you.
                    Soon you'll be able to manage endpoints, monitor API performance, configure authentication,
                    and access detailed analytics for all your API integrations.
                </Typography>
            </Box>
        </Container>
    );
};

export default ApiPage; 